import React from 'react';
import styles from './ContrastTitle.module.scss';

const ContrastTitle = ({ children }) => <div className={styles.contrastTitle}>{children}</div>;

export default ContrastTitle;
